import { Contents } from 'epubjs';
import path from 'path';
import useUiStore from '../../stores/ui';
import useReaderEngine from '../use-reader-engine';

const useAudioBooksView = () => {
  const { book, manifest, getBookResourceUrl } = useReaderEngine();
  const { pages } = manifest.value;
  const { themeMode } = useUiStore();

  const updateLayoutForPagesLinks = (contents: Contents) => {
    const { document } = contents;
    const pageAdditionalText = 'Sida'; // TODO translate me
    const pagesElements = document.querySelectorAll('.page-normal');
    if (pagesElements && pagesElements.length) {
      for (let i = 0; i < pagesElements.length; i++) {
        const pageNumElement = pagesElements[i].querySelector('span');
        if (pageNumElement) {
          const solidLine = document.createElement('hr');
          solidLine.classList.add('hr-line');

          const wrapper = document.createElement('div');
          wrapper.classList.add('page-normal-container');

          pageNumElement.innerHTML = `${pageAdditionalText} ${pageNumElement.innerHTML}`.trim();
          // pages[i].parentNode?.insertBefore(solidLine, pages[i]);
          pagesElements[i].parentNode?.insertBefore(wrapper, pagesElements[i]);
          wrapper.appendChild(pagesElements[i]);
        }
      }
    }
  };

  const colouriseByPage = (contents: Contents, firstTimeColourised: boolean = true) => {
    const bgColor = themeMode === 'dark' ? '#1A1F23' : '#F2F5F8';
    /* The code snippet below is to color the background of every other page in a different color */
    const { href } = contents.document.head.getElementsByTagName('base')[0];
    let filename = '';
    const prefix = getBookResourceUrl('');
    if (href.startsWith(prefix)) {
      filename = href.substring(prefix.length);
    } else {
      filename = path.parse(href).base;
    }
    let pageIndex: number;
    // @ts-ignore
    if (contents.document.body.childNodes[0].classList?.contains('page-normal-container') !== true) {
      // If the first element is not a page-break, so the element belongs to the previous page
      pageIndex = -1;
    } else {
      // First element is a page-break, so we find the first page in the pageList with the matching file name
      // @ts-ignore
      pageIndex = pages.findIndex((page) => page.href.startsWith(`${filename}#`));
    }

    // Find the previous page if required
    while (pageIndex === -1 && book.value.spine) {
      const section = book.value.spine.get(filename);
      if ((section && section.index === 0) || section === null) {
        // we are on the first page, so no previous page
        break;
      }

      const currentSection = book.value.spine.get(filename);
      if (!currentSection) {
        break;
      }
      const previous = book.value.spine.get(currentSection.index - 1);
      filename = previous.href;
      // @ts-ignore
      pageIndex = pages.findLastIndex((page) => page.href.startsWith(`${previous.href}#`));
    }

    let page: { page: number; href: string };
    if (pageIndex === -1) {
      page = { page: 1, href: '' }; // dummy page number for white background
    } else {
      // @ts-ignore
      page = pages[pageIndex];
    }
    contents.document.querySelectorAll('.page-normal-container, h1, h2, h3, h4, h5, h6').forEach((node) => {
      if (node.classList.contains('page-normal-container')) {
        pageIndex += 1;
        // @ts-ignore
        page = pages[pageIndex];
      }
      if (
        (node.tagName === 'H1' ||
          node.tagName === 'H2' ||
          node.tagName === 'H3' ||
          node.tagName === 'H4' ||
          node.tagName === 'H5' ||
          node.tagName === 'H6') &&
        !node.classList.contains('title') &&
        firstTimeColourised
      ) {
        const wrapper = document.createElement('div');
        wrapper.classList.add('heading-wrapper');
        node.parentNode?.insertBefore(wrapper, node);
        wrapper.appendChild(node);
      }
      // For some books pageList object could be not complete or broken. So adding a check if page data is present.
      if (page && page.page % 2 === 0) {
        // @ts-ignore
        if (node.parentNode?.classList.contains('heading-wrapper')) {
          // @ts-ignore
          node.parentNode.style.backgroundColor = bgColor;
        } else {
          // @ts-ignore

          node.style.backgroundColor = bgColor;
        }
      }
    });
  };

  const setTheme = (contents: Contents) => {
    contents.document.body.classList.remove('light', 'dark');
    contents.document.body.classList.add(themeMode);
  };

  return {
    updateLayoutForPagesLinks,
    setTheme,
    colouriseByPage,
  };
};

export default useAudioBooksView;
